module.exports = __webpack_public_path__ + "img/widgets5.b016d947.png";